import { createFileRoute } from '@tanstack/react-router';
import { BroadcastTriggerDeliveryRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastTriggerDeliveryRoute() {
  const { broadcastId, triggerId, deliveryId } = Route.useParams();
  return <BroadcastTriggerDeliveryRouteView broadcastId={broadcastId} triggerId={triggerId} deliveryId={deliveryId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/$deliveryId',
)({
  component: BroadcastTriggerDeliveryRoute,
});
